<central-login-header [platform]="platform"></central-login-header>
<div class="content">
    <div class="alert alert-danger" *ngIf="errorMessage">
        {{ errorMessage | translate }}
    </div>
</div>
<central-login-footer></central-login-footer>
<central-login-background-slider [platform]="platform" ></central-login-background-slider>

<form id="goToPlatformForm" action="" method="post">
    <input type="hidden" name="central_access_token" value="">
    <input type="hidden" name="central_refresh_token" value="">
    <input type="hidden" name="refresh_token" value="">
    <input type="hidden" name="access_token" value="">
    <input type="hidden" name="expires_in" value="">
    <input type="hidden" name="force_token_refresh" value="false">
</form>